export enum ReportPeriod {
    DAILY = "DAILY",
    MONTHLY = "MONTHLY",
}
